import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, UserCheck, AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import logoLight from "@/assets/logo-light.png";

export default function AcceptInvite() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get(`/public/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(e.response?.data?.detail || "Convite inválido")); }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (senha !== confirmar) return toast.error("As senhas não coincidem");
    setLoading(true);
    try {
      await api.post("/auth/accept-invite", { token, nova_senha: senha });
      toast.success("Senha criada! Faça login para começar."); navigate("/login");
    } catch (err) { toast.error(err.response?.data?.detail || "Erro"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white" data-testid="invite-page">
      <div className="w-full max-w-sm fade-up">
        <img src={logoLight} alt="TRT" className="h-14 w-auto mb-6" />
        {error ? <div className="flex items-center gap-2 text-red-600" data-testid="invite-error"><AlertTriangle className="w-5 h-5" /> {error}</div>
          : !info ? <Loader2 className="w-6 h-6 animate-spin gold-text" /> : (
            <form onSubmit={submit} className="space-y-4">
              <h2 className="text-2xl font-bold tracking-tight flex items-center gap-2"><UserCheck className="w-5 h-5 gold-text" /> Bem-vindo(a), {info.name}!</h2>
              <p className="text-slate-500 text-sm">Você foi convidado para <b>{info.empresa}</b>. Crie sua senha para acessar com <b>{info.email}</b>.</p>
              <div><Label>Senha (mín. 8)</Label><Input type="password" required minLength={8} value={senha} onChange={(e) => setSenha(e.target.value)} className="mt-1.5" data-testid="invite-pw" /></div>
              <div><Label>Confirmar senha</Label><Input type="password" required value={confirmar} onChange={(e) => setConfirmar(e.target.value)} className="mt-1.5" data-testid="invite-pw2" /></div>
              <Button type="submit" disabled={loading || senha.length < 8} className="w-full bg-gold hover:bg-[hsl(var(--gold-hover))] text-black h-11 font-semibold" data-testid="invite-submit">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Criar senha e entrar"}</Button>
            </form>
          )}
        <Link to="/login" className="mt-6 block text-center text-sm text-slate-500 hover:text-slate-800">Ir para o login</Link>
      </div>
    </div>
  );
}
